import { Route } from 'react-router-dom';
import { MONEY_PERMISSIONS } from '@invento/shared';
import { PermissionGuard } from '@/navigation/guards/permission-guard';
import { lazyNamed } from '../lazy-named';
import { TenantPreviewRouteFrame } from './route-frames';

const loadMoney = () => import('@/features/money');
const MoneyCustomerCreditPage = lazyNamed(loadMoney, 'MoneyCustomerCreditPage');
const MoneyHomePage = lazyNamed(loadMoney, 'MoneyHomePage');
const MoneyReconciliationPage = lazyNamed(loadMoney, 'MoneyReconciliationPage');
const MoneyTransactionsPage = lazyNamed(loadMoney, 'MoneyTransactionsPage');

export function moneyRoutes() {
  return (
    <Route element={<TenantPreviewRouteFrame />}>
      <Route
        path="money"
        element={
          <PermissionGuard required={MONEY_PERMISSIONS.ACCOUNT_READ}>
            <MoneyHomePage />
          </PermissionGuard>
        }
      />
      <Route
        path="money/transactions"
        element={
          <PermissionGuard required={MONEY_PERMISSIONS.TRANSACTION_READ}>
            <MoneyTransactionsPage />
          </PermissionGuard>
        }
      />
      <Route
        path="money/reconciliation"
        element={
          <PermissionGuard
            requiredAll={[
              MONEY_PERMISSIONS.ACCOUNT_READ,
              MONEY_PERMISSIONS.RECONCILIATION_READ,
            ]}
          >
            <MoneyReconciliationPage />
          </PermissionGuard>
        }
      />
      <Route
        path="money/customer-credit"
        element={
          <PermissionGuard required={MONEY_PERMISSIONS.CUSTOMER_CREDIT_READ}>
            <MoneyCustomerCreditPage />
          </PermissionGuard>
        }
      />
    </Route>
  );
}
